<template>
  <div class="login_panel">
    <router-link class="back" to="/" tag="button"><img src="../assets/next.png"></router-link>
    <div class="logo_wrapper">
    <h1 class="lb">Meble</h1>
    <h2 class="ls">AGMAR</h2>
    <p class="lt">Panel administracyjny</p>
    </div>
    <h2 class="heading_text">Zaloguj się</h2>
    <form v-on:submit.prevent class="login_box">
      <p v-if="user.email">{{message}}</p>
      <div class="error">
        <p v-if="errorCode === 'auth/wrong-password'">Wprowadzono złe hasło!</p>
        <p v-if="errorCode === 'auth/user-not-found'">Nie znaleziono użytkownika o podanym emailu, sprawdź wprowadzone dane.</p>
        <p v-if="errorCode === 'auth/invalid-email'">Wprowadzony adres email jest nieprawidłowy, sprawdź czy dobrze go wpisałeś.</p>  
      </div>
      <div>
        <label class="login_label" for="login">Email</label>
        <input type="text" class="login" placeholder="Wprowadź email" v-model="email">
      </div>
      <div>
        <label class="password_label" for="password">Hasło</label>
        <input type="password" class="password" placeholder="Wprowadź hasło" v-model="password">
      </div>
      <input type="submit" value="Zaloguj" class="logBtn" @click="signIn">
    </form>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
    name: 'login_panel',
    methods:{
      ...mapMutations(['signIn'])
    },
    computed:{
      ...mapState({
        errorMessage: state => state.login.error.message,
        errorCode: state => state.login.error.code,
        message: state => state.login.message,
        user: state => state.login.user
      }),
      email:{
        get(){
          return this.$store.state.login.email
        },
        set(value){
          return this.$store.commit('setEmail', value);
        }
      },
      password:{
        get(){
          return this.$store.state.login.password
        },
        set(value){
          return this.$store.commit('setPassword', value);
        }
      }
    },
}
</script>

<style scoped lang="scss">
.logo_wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 16px;
}
.lb{
  font-size: 44px;
  line-height: 30px;
}
.ls{
  font-size: 38px;
  line-height: 36px;
  font-weight: lighter;
}
.lt{
  line-height: 14px;
  font-size: 14px;
  font-weight: bold;
}
.login_panel{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: darkcyan;
  width: 100%;
  height: 100vh;
}
.login_box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 34px;
  div{
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
.heading_text{
  margin-bottom: 60px;
  color: white;
}
.logBtn{
  background: none;
  border: 2px solid white;
  color: white;
  width: 100%;
  height: 40px;
  border-radius: 20px;
  margin-top: 20px;
  &:focus{
    outline: none;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    background: white;
    color: darkcyan;
    font-weight: bold;
  }
}
.login, .password{
  border-radius: 20px;
  border: none;
  background: rgba(51, 170, 170, 0.788);
  width: 100%;
  height: 40px;
  color: white;
  padding: 0 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  &::placeholder{
    color: rgba(255, 255, 255, 0.589);
  }
  &:focus{
    outline: none;
  }
}
.login_label, .password_label{
  color: white;
  margin: 6px 0;
  font-size: 12px;
}
.back{
  background: none;
  border: none;
  transform: rotate(180deg);
  position: absolute;
  top: 34px;
  left: 34px;
}
@media (min-width: 1440px){
  .login_box{
    width: 400px;
    height: 400px;
    background: darkcyan;
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  }
  .login_panel{
    background: rgb(61, 185, 185);
  }
  .heading_text{
    font-size: 36px;
  }
  .logBtn{
    width: 60%;
  }
}

</style>